import React from 'react';
import { useTranslation } from 'react-i18next';
import { PublicInfo } from '@app/components/public/PublicInfo/PublicInfo';
import { PageTitle } from '@app/components/common/PageTitle/PageTitle';
import { BaseCard } from '@app/components/common/BaseCard/BaseCard';
import { BaseCol } from '@app/components/common/BaseCol/BaseCol';
import { BaseRow } from '@app/components/common/BaseRow/BaseRow';
import { useLocation } from 'react-router-dom';
import { GenerateInvoice } from '@app/components/public/PublicInfo/GenerateInvoice';

const GenerateInvoicePage: React.FC = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const { agency, revenue, category } = location.state;
  return (
    <>
      <PageTitle>{t('profile.nav.personalInfo.title')}</PageTitle>
      <BaseRow gutter={[30, 30]}>
        <BaseCol xs={24} sm={24} xl={24}>
          <BaseCard id="step-form" padding="1.25rem">
            <GenerateInvoice agency={agency} revenue={revenue} category={category} />
          </BaseCard>
        </BaseCol>
      </BaseRow>
    </>
  );
};

export default GenerateInvoicePage;
